import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/cc-jcb': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M431.5 244.3V212C472.7 212 470 212.2 470 212.2 477.3 213.5 483.3 219.5 483.3 228.2 483.3 237 477.3 242.7 470 244 468.8 244.4 466.7 244.3 431.5 244.3zM474.3 264.5C471.5 263.8 471 264 431.5 264V299C471.1 299 471.5 299.2 474.3 298.5 481.8 297 487.8 290.5 487.8 281.5 487.8 272.8 481.8 266 474.3 264.5zM576 80V432C576 458.5 554.5 480 528 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H528C554.5 32 576 53.5 576 80zM182 192.3H125C125 259.4 135.7 302 89.2 302 69.7 302 50.4 296.3 32 287.2V315.2C62 323.5 100 323.5 100 323.5 197.9 323.5 182 275.8 182 192.3zM360.5 196.8C297.1 180.8 195.5 181.9 195.5 256.1 195.5 333.2 303.7 329.7 360.5 315.3V287C312.9 311.7 253 309 253 256S312.8 200.4 360.5 224.8V196.8zM544 286.5C544 268 527.5 256 506 254.5V253.7C525.5 251 536.3 238.2 536.3 223.5 536.3 204.5 520.6 193.5 499.3 192.5 499.3 192.5 505.6 192.2 379 192.2V319.7H501.7C526 319.8 544 306.8 544 286.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/cc-jcb.js
// module id = U5TU
// module chunks = 144